<script setup>
import {computed} from "vue";
import {useStore} from "vuex";

import CodeRender from "@/components/onsiteEditor/components/installation/CodeRender.vue";
import InstallationCheckButton from "@/components/onsiteEditor/components/installation/InstallationCheckButton.vue";
import TabContainer from "@/components/global-themed/tabs/TabContainer.vue";
import TabItem from "@/components/global-themed/tabs/TabItem.vue";

const store = useStore();
const emit = defineEmits(['goToAssisted', 'back']);

defineProps({
  isOnboarding: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const tabs = computed(() => store.getters['onsiteEditorInstallation/installation']);
const activeTab = computed(() => store.getters['onsiteEditorInstallation/activeFilter']);
const user = computed(() => store.getters['user/user']);
const activeTabContent = computed(() => tabs.value.find(item => item.value === activeTab.value));
</script>

<template>
  <div class="tw-flex tw-flex-col tw-gap-8">
    <TabContainer>
      <TabItem
        v-for="(tab, key) in tabs"
        :key="key"
        :active="activeTab === tab.value"
        class="tw-flex tw-items-center tw-justify-center tw-gap-3"
        @click="store.dispatch('onsiteEditorInstallation/setActiveFilter', tab.value)"
      >
        <span class="tw-font-bold">{{ tab.text }}</span>
      </TabItem>
    </TabContainer>

    <div class="tw-text-base tw-text-left">
      <CodeRender
        :website-id="user.active_website?.id"
        :text="activeTabContent.description"
      />
    </div>

    <InstallationCheckButton
      class="tw-mt-5 tw-text-base"
      :is-onboarding="isOnboarding"
      :using-global-styling="true"
      @go-to-assisted="emit('goToAssisted')"
      @back="emit('back')"
    />
  </div>
</template>
